import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/ui/buttons")({
    beforeLoad: () => {
        throw redirect({ to: "/design/components/buttons", replace: true });
    },
});
